import React, { useState } from "react";
import { useParams } from "react-router";
import { useHistory } from "react-router-dom";
import matrixData from "../../myfin_v2/data/matrix_data.json";
import { ReactComponent as UpIcon } from "../../myfin_v2/assets/icons/up_arrow.svg";
import { ReactComponent as DownIcon } from "../../myfin_v2/assets/icons/down_arrow.svg";
import { ReactComponent as DownRightIcon } from "../../myfin_v2/assets/icons/down_right.svg";
import { formatAmount } from "../../utils/formatAmount";

const DynamicTable = ({ matrices }) => {
  const history = useHistory();
  const { workspaceId } = useParams();
  const [expandedRows, setExpandedRows] = useState([]);
  console.log("matrices", matrices);

  const data = matrices;
  const toggleExpand = (id) => {
    setExpandedRows((prev) =>
      prev.includes(id) ? prev.filter((row) => row !== id) : [...prev, id]
    );
  };

  const ViewTask = () => {
    history.push(`/bookclosure/${workspaceId}`);
  };

  const isRowExpanded = (id) => expandedRows.includes(id);
  return (
    <div
      style={{
        backgroundColor: "#f4f6f8",
        padding: "0px 20px 20px 20px",
        fontFamily: "'DM Sans', sans-serif !important",
        maxHeight: "85vh",
        overflowY: "auto",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: "0 8px",
          border: "none",
        }}
      >
        <thead>
          <tr
            style={{
              textTransform: "uppercase",
              fontSize: "12px",
              color: "#7c8b9a",
              textAlign: "left",
              border: "none",
            }}
          >
            <th
              style={{
                padding: "8px",
                paddingLeft: "18px",
                border: "none",
                width: "450px",
                textAlign: "left",
                color: "#33584E",
                fontSize: "14px",
              }}
            >
              Mapping
            </th>
            <th
              style={{
                border: "none",
                textAlign: "right",
                color: "#33584E",
                fontSize: "14px",
              }}
            >
              Uploaded TB Balance
            </th>
            <th
              style={{
                border: "none",
                textAlign: "right",
                color: "#33584E",
                fontSize: "14px",
              }}
            >
              Adjustments
            </th>
            <th
              style={{ border: "none", textAlign: "right", fontSize: "14px" }}
            >
              Updated Balance
            </th>
            <th
              style={{
                border: "none",
                textAlign: "right",
                color: "#33584E",
                fontSize: "14px",
              }}
            >
              Module
            </th>
            <th
              style={{
                border: "none",
                textAlign: "right",
                color: "#33584E",
                fontSize: "14px",
              }}
            >
              Task
            </th>
          </tr>
        </thead>
        <tbody>
          {data.map((item, index) => (
            <MatrixRow key={index} item={item} level={0} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

const MatrixRow = ({ item, level }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const hasSubgroup = item.subgroup && item.subgroup.length > 0;
  const hasLedgers = item.ledgers && item.ledgers.length > 0;

  const canExpand = hasSubgroup || (level === 2 && hasLedgers);

  const levelColors = [
    {
      background: "#EFF7F0",
      labelBg: "#3AB67D",
      borderColor: "#D3E1D5",
      color: "#000000",
    },
    {
      background: "#EBF1FD",
      labelBg: "#639FF0",
      borderColor: "#D1D8E3",
      color: "#000000",
    },
    {
      background: "#FDF9F2",
      labelBg: "#F6C858",
      borderColor: "#E2DFD7",
      color: "#000000",
    },
    {
      background: "#F2FCFD",
      labelBg: "#60C8DA",
      borderColor: "#D7E0E2",
      color: "#000000",
    },
  ];

  const badgeText = level < 3 ? `L${level + 1}` : "LE";
  const currentLevel = levelColors[level] || levelColors[3];

  const badgeStyle = {
    fontSize: "12px",
    fontWeight: "400",
    borderRadius: "4px",
    padding: "4px 6px",
    marginRight: "8px",
    display: "inline-block",
    minWidth: "24px",
    textAlign: "center",
    backgroundColor: currentLevel.labelBg,
    color: "#ffffff",
  };

  const badgeStyleLE = {
    fontSize: "12px",
    fontWeight: "400",
    borderRadius: "4px",
    padding: "4px 6px",
    marginRight: "8px",
    display: "inline-block",
    minWidth: "24px",
    textAlign: "center",
    backgroundColor: "#60C8DA",
    color: "#ffffff",
  };

  const rowStyle = {
    backgroundColor: "#ffffff",
    // boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    cursor: canExpand ? "pointer" : "default",
    border: "none",
  };

  const cellStyle = {
    paddingRight: "12px",
    textAlign: "left",
    backgroundColor: "#ffffff",
    border: "none",
    fontSize: "15px",
  };

  const cardCellStyle = {
    padding: "12px",
    textAlign: "left",
    backgroundColor: currentLevel.background,
    color: currentLevel.color,
    border: `1px solid ${currentLevel.borderColor}`,
    borderRadius: "8px",
    width: "100%",
  };

  const cardCellStyleLE = {
    padding: "12px",
    textAlign: "left",
    backgroundColor: "#F2FCFD",
    color: "#000000",
    border: `1px solid #D7E0E2`,
    borderRadius: "8px",
    width: "100%",
  };

  return (
    <>
      <tr
        style={rowStyle}
        onClick={() => canExpand && setIsExpanded(!isExpanded)}
      >
        <td
          style={{
            ...cellStyle,
            // paddingLeft: `${level * 10 + 12}px`,
            width: "450px",
            border: "none",
            backgroundColor: "#f4f6f8",
          }}
        >
          <div
            style={{
              ...cardCellStyle,
              display: "flex",
              alignItems: "center",
              paddingLeft: `${level * 10 + 12}px`,
            }}
          >
            {level !== 0 && (
              <>
                <DownRightIcon />
                &ensp;
              </>
            )}
            <span style={badgeStyle}>{badgeText}</span>
            <span style={{ flexGrow: 1 }}>{item.name}</span>
            {canExpand && (
              <span style={{ marginLeft: "auto" }}>
                {isExpanded ? <UpIcon /> : <DownIcon />}
              </span>
            )}
          </div>
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {formatAmount(item.uploadedTBBalance) ?? "-"}
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {formatAmount(item.adjustmentAmount) ?? "-"}
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}>
          {formatAmount(item.adjustedAmount) ?? "-"}
        </td>
        <td style={{ ...cellStyle, textAlign: "right" }}></td>
        <td style={{ ...cellStyle, textAlign: "right" }}></td>
      </tr>

      {isExpanded &&
        hasSubgroup &&
        item.subgroup.map((sub, idx) => (
          <MatrixRow key={idx} item={sub} level={level + 1} />
        ))}

      {isExpanded &&
        level === 2 &&
        hasLedgers &&
        item.ledgers.map((ledger, idx) => (
          <tr key={`ledger-${idx}`} style={rowStyle}>
            <td
              style={{
                ...cellStyle,

                width: "450px",
                backgroundColor: "#f4f6f8",
              }}
            >
              <div
                style={{
                  ...cardCellStyleLE,
                  paddingLeft: `${(level + 1) * 10 + 12}px`,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <DownRightIcon />
                &ensp;
                <span style={badgeStyleLE}>LE</span>
                {ledger.name}
              </div>
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {formatAmount(ledger.uploadedTBBalance) ?? "-"}
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {formatAmount(ledger.adjustmentAmount) ?? "-"}
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>
              {formatAmount(ledger.adjustedAmount) ?? "-"}
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}></td>
            <td style={{ ...cellStyle, textAlign: "right" }}></td>
          </tr>
        ))}
    </>
  );
};

export default DynamicTable;
